import { html, rune, View } from 'rune-ts';
import klass from './CaseSection.module.scss';
import { typoPcMo } from '../../../../../shared/typography/typo';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { htmlIf } from '../../../../../shared/util';
import { CaseCard } from './CaseCard';

export class CaseSection extends View {
  swiper?: Swiper;

  constructor() {
    super({});
  }

  override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    const texts = {
      case_title: html.preventEscape(ET(`mps2::landing::plus::${is_mobile ? 'mo_' : ''}case_title`)),
      case_mcn_title: html.preventEscape(ET(`mps2::landing::plus::case_mcn_title`)),
      case_mcn_description: html.preventEscape(
        ET(`mps2::landing::plus::${is_mobile ? 'mo_' : ''}case_mcn_description`),
      ),
      case_game_title: html.preventEscape(ET(`mps2::landing::plus::case_game_title`)),
      case_game_description: html.preventEscape(
        ET(`mps2::landing::plus::${is_mobile ? 'mo_' : ''}case_game_description`),
      ),
      case_webtoon_title: html.preventEscape(ET(`mps2::landing::plus::case_webtoon_title`)),
      case_webtoon_description: html.preventEscape(
        ET(`mps2::landing::plus::${is_mobile ? 'mo_' : ''}case_webtoon_description`),
      ),
      case_entertain_title: html.preventEscape(ET(`mps2::landing::plus::case_entertain_title`)),
      case_entertain_description: html.preventEscape(
        ET(`mps2::landing::plus::${is_mobile ? 'mo_' : ''}case_entertain_description`),
      ),
      case_creator_title: html.preventEscape(ET(`mps2::landing::plus::case_creator_title`)),
      case_creator_description: html.preventEscape(
        ET(`mps2::landing::plus::${is_mobile ? 'mo_' : ''}case_creator_description`),
      ),
    };

    return html`
      <section class="${klass.container} swiper commerce_swiper">
        <div class="${klass.title_wrapper}">
          <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '48_bold', mo: '28_bold' })}">
            ${texts.case_title}
          </div>
        </div>
        <div class="${klass.content} swiper-wrapper">
          <div class="${klass.slide} swiper-slide">
            ${new CaseCard({
              title: texts.case_mcn_title,
              description: texts.case_mcn_description,
              imageUrl: `//s3.marpple.co/files/u_14345/2024/6/original/plus/section3/case-1.png`,
            })}
          </div>
          <div class="${klass.slide} swiper-slide">
            ${new CaseCard({
              title: texts.case_game_title,
              description: texts.case_game_description,
              imageUrl: `//s3.marpple.co/files/u_14345/2024/6/original/plus/section3/case-3.png`,
            })}
          </div>
          <div class="${klass.slide} swiper-slide">
            ${new CaseCard({
              title: texts.case_webtoon_title,
              description: texts.case_webtoon_description,
              imageUrl: `//s3.marpple.co/files/u_14345/2024/6/original/plus/section3/case-2.png`,
            })}
          </div>
          <div class="${klass.slide} swiper-slide">
            ${new CaseCard({
              title: texts.case_entertain_title,
              description: texts.case_entertain_description,
              imageUrl: `//s3.marpple.co/files/u_14345/2024/6/original/plus/section3/case-4.png`,
            })}
          </div>
          <div class="${klass.slide} swiper-slide">
            ${new CaseCard({
              title: texts.case_creator_title,
              description: texts.case_creator_description,
              imageUrl: `//s3.marpple.co/files/u_14345/2024/6/original/plus/section3/case-5.png`,
            })}
          </div>
        </div>
        ${htmlIf(html`<div class="swiper-pagination ${klass.pagination}"></div>`, is_mobile)}
      </section>
    `;
  }

  override onRender() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    if (is_mobile) {
      this.swiper = this._onLoadAdSwiper();
    }
  }

  private _onLoadAdSwiper() {
    return new Swiper('.commerce_swiper', this._createSwiperOption());
  }

  private _createSwiperOption() {
    return {
      modules: [Pagination],
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
        progressbarFillClass: `${klass.progressbar_fill} swiper-pagination-progressbar-fill`,
      } as const,
    };
  }
}
